import { Card, CardContent } from '@/components/ui/card';

interface Investor {
  name: string;
  title: string;
  logos: string[];
}

const investors: Investor[] = [
  {
    name: "Sachin Bhatia",
    title: "Cofounder at Exotel",
    logos: ["/lovable-uploads/f0e559de-57be-429d-8ec3-fdb35842aa81.png", "/lovable-uploads/32334656-9272-41cd-b728-c0ce02ee72f0.png"]
  },
  {
    name: "Gaurav Roy",
    title: "CTO at Accelya",
    logos: ["/lovable-uploads/f0e559de-57be-429d-8ec3-fdb35842aa81.png", "/lovable-uploads/32334656-9272-41cd-b728-c0ce02ee72f0.png"]
  },
  {
    name: "Kechit Goel",
    title: "VP of Techonology at upGrad",
    logos: ["/lovable-uploads/f0e559de-57be-429d-8ec3-fdb35842aa81.png", "/lovable-uploads/32334656-9272-41cd-b728-c0ce02ee72f0.png"]
  },
  {
    name: "Akshat Nair",
    title: "Data Engineering Manager at Doordash",
    logos: ["/lovable-uploads/f0e559de-57be-429d-8ec3-fdb35842aa81.png", "/lovable-uploads/32334656-9272-41cd-b728-c0ce02ee72f0.png"]
  },
];

export const InvestorsSection = () => {
  return (
    <section className="mb-20">
      <h2 className="text-3xl font-bold text-brand-darkgrey text-center mb-12">Our Investors</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {investors.map((investor) => (
          <Card key={investor.name} className="hover:shadow-md transition-shadow duration-300">
            <CardContent className="p-4">
              <h3 className="font-semibold text-lg text-brand-darkgrey mb-2">{investor.name}</h3>
              <p className="text-brand-grey mb-4">{investor.title}</p>
              <div className="flex gap-4 items-center">
                {investor.logos.map((logo, index) => (
                  <img
                    key={index}
                    src={logo}
                    alt={`${investor.name} association`}
                    className="h-8 object-contain"
                  />
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};
